/**
 * Service: reportingApi
 */
angular.module('acme.common.service.reportingApi', [
  'acme.common.factory.QueryStringBuilder',
  'acme.common.service.helpers'
])
.constant('ReportingConstant', {
  async: {
    status: {
      pending: 'Pending',
      processing: 'Processing',
      completed: 'Completed',
      error: 'Error'
    }
  }
})
.service('ReportingApiService', ['$http', '$q', 'ReportingConstant', 'QueryStringBuilderFactory', 'HelpersService', function($http, $q, ReportingConstant, QueryStringBuilderFactory, HelpersService) {

    function dateToString(d) {
      return [d.getFullYear(), d.getMonth()+1,d.getDate()].join('-');
    }

    return {

      service: '',

      init: function (endpoint) {
        this.service = endpoint + '/analytics';
        this.datasources.service = this.service + '/metadata';
        this.definitions.service = this.service + '/report/definitions';
        this.reports.service = this.service + '/report/execute';
        this.asyncReports.service = '/v2/api/async/report';
        this.asyncReports.csvUrl = '/v2/api/async/report/csv';
        return this;
      },

      datasources:  {

        service: '',

        list: function () {
          return $http({
            method: 'get',
            url: this.service
          });
        },

        get: function(name) {
          return $http({
            method: 'get',
            url: this.service + '/collection/' + name
          });
        }
      },

      definitions: {
        service: '',

        list: function(props) {
          var q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + q
          });
        },

        get: function(id) {
          return $http({
            method: 'get',
            url: this.service + '/' + id
          });
        },

        create: function(props) {
          return $http({
            method: 'post',
            url: this.service,
            data: {
              name: props.reportName,
              description: props.reportDescription,
              queryExpression: {
                collectionName: props.dataSourceName
              }
            }
          });
        },
        createCopy: function(props) {
          return $http({
            method: 'post',
            url: this.service,
            data: props
          });
        },

        update: function(props) {
          return $http({
            method: 'put',
            url: this.service + '/' + props.id,
            data: props
          });
        },

        remove: function(id) {
          return $http({
            method: 'delete',
            url: this.service + '/' + id
          });
        },

        duplicate: function(id) {
          return $http({
            method: 'post',
            url: this.service.replace(/v1/, 'v2') + '/duplicate/' + id
          });
        }
      },

      reports: {

        // Runs with report `id` field ONLY
        execute: function(props) {
          var q,
              qs;

          if (props) {

            if (props.startDate && props.startDate instanceof Date) {
              props.startDate = dateToString(props.startDate);
            }

            if (props.endDate && props.endDate instanceof Date) {
              props.endDate = dateToString(props.endDate);
            }

            qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['reportDefinitionId', 'limit', 'dateRangeField', 'startDate', 'endDate', 'startDateTime', 'endDateTime']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: this.service + '/' + props.id + q
          });
        },

        // Runs with `queryExpression` ONLY
        query: function(props) {

          var q,
              qs;

          if (props) {
            if (props.startDate && props.startDate instanceof Date) {
              props.startDate = dateToString(props.startDate);
            }

            if (props.endDate && props.endDate instanceof Date) {
              props.endDate = dateToString(props.endDate);
            }

            qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['dummy', 'reportDefinitionId', 'dateRangeField', 'startDate', 'endDate', 'startDateTime', 'endDateTime']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'post',
            url: this.service + q,
            data: props.queryExpression
          });

        }

      },

      asyncReports: {

        /**
         * Create Async Report
         * @param props
         * @returns {angular.IPromise<any>}
         */
        create: function(props) {

          // Format dates
          if (props) {
            if (props.startDate && props.startDate instanceof Date) {
              props.startDate = dateToString(props.startDate);
            }

            if (props.endDate && props.endDate instanceof Date) {
              props.endDate = dateToString(props.endDate);
            }
          }

          return $http({
            method: 'post',
            url: this.service,
            data: props
          })
            .then(HelpersService.utils.unwrapAcmeResponse);
        },

        /**
         * List All Async Reports
         * @param query
         * @returns {angular.IPromise<any>}
         */
        list: function(query) {
          return $http.get(this.service, {
            params: {
              page: query.page || null,
              pageSize: query.pageSize || null,
              search: query.search || null,
              sortDirection: query.sortDirection || null,
              sortField: query.sortField || null,
              startTime: query.startTime || null,
              endTime: query.endTime || null
            }
          });
        },

        /**
         * Get the Async Reports for a Report
         * @param {string} reportUuid - Report Definition ID
         * @param {Object} [query] - optional
         * @returns {angular.IPromise<any>}
         */
        getByReportId: function(reportUuid, query) {
          
          var optionalQuery = query || {};
          
          return $http.get(this.service, {
            params: {
              reportUuid: reportUuid,
              page: optionalQuery.page || null,
              pageSize: optionalQuery.pageSize || null,
              sortDirection: optionalQuery.sortDirection || null,
              sortField: optionalQuery.sortField || null,
              startTime: optionalQuery.startTime || null,
              endTime: optionalQuery.endTime || null
            }
          })
            .then(function(response) {
              return response.data.payload;
            });
        },

        /**
         * Check if an Async Report has completed or not
         * @param asyncReport - Async Report
         * @returns {angular.IPromise<any>}
         */
        isReportCompleted: function (asyncReport) {
          var report = null; // Default is NOT completed

          if (asyncReport.status === ReportingConstant.async.status.completed) {
            report = asyncReport;
          } else if (asyncReport.status === ReportingConstant.async.status.error) {

            // We reject if there was a problem with the report
            report = $q.reject(asyncReport);
          }

          return report;
        },

        /**
         * Get an Async Report by ID
         * @param id
         * @returns {angular.IPromise<any>}
         */
        get: function(id) {
          return $http.get([this.service, id].join('/'))
            .then(HelpersService.utils.unwrapAcmeResponse);
        },

        getJson: function (id) {
          return $http.get([this.service, 'json', id].join('/'))
            .then(HelpersService.utils.unwrapAcmeResponse);
        },

        /**
         * Remove / delete Async Report
         * @param id
         * @returns {angular.IHttpPromise<any>}
         */
        remove: function (id) {
          return $http.delete([this.service, id].join('/'));
        }
      }
    };
}]);